import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import Varlet from '@varlet/ui';
import '@varlet/ui/es/style';
import 'ant-design-vue/dist/antd.css';
import VueFullpage from 'vue-fullpage.js';
import { setupDirectives } from './directives';
// import 'default-passive-events'
import { isMobile } from '@/utils';
import { getUrllink } from '@/api';
import { registerPulgs } from '@/plugins';
import '@/utils/rem';
import '@/global.scss';

router.beforeEach((to, from, next) => {
  if (Object.keys(to.meta).length > 0 && to.matched.length > 0) {
    const this_meta = to.matched[to.matched.length - 1].meta;

    if (this_meta.title) {
      document.title = this_meta.title;
      document
        .querySelector('meta[name="ogtitle"]')
        .setAttribute('content', this_meta.title);
    }

    const head = document.getElementsByTagName('head');
    if (this_meta.keywords) {
      if (document.querySelector('meta[name="keywords"]')) {
        document
          .querySelector('meta[name="keywords"]')
          .setAttribute('content', this_meta.keywords);
      } else {
        const meta_keyword = document.createElement('meta');
        meta_keyword.setAttribute('name', 'keywords');
        meta_keyword.setAttribute('content', this_meta.keywords);
        head[0].appendChild(meta_keyword);
      }
    }

    if (this_meta.description) {
      document
        .querySelector('meta[name="ogdesc"]')
        .setAttribute('content', this_meta.description);
      if (document.querySelector('meta[name="description"]')) {
        document
          .querySelector('meta[name="description"]')
          .setAttribute('content', this_meta.description);
      } else {
        const meta_description = document.createElement('meta');
        meta_description.setAttribute('name', 'description');
        meta_description.setAttribute('content', this_meta.description);
        head[0].appendChild(meta_description);
      }
    }
  }
  next();
});
document
  .querySelector('meta[name="ogimg"]')
  .setAttribute('content', `${location.origin}/img/logo.png`);
document
  .querySelector('meta[name="ogurl"]')
  .setAttribute('content', location.origin);

const app = createApp(App);

setupDirectives(app);
registerPulgs(app);
app.use(Antd).use(router).use(VueFullpage).use(Varlet).mount('#app');
